// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","lg":"992px","title":"HowTheSaleWorks_title__2OW5j","howItWorks":"HowTheSaleWorks_howItWorks__XAdiM"};